"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var currency_1 = require("@nerdwallet/currency");
var Help_1 = __importDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Help"));
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var tooltip_content_1 = require("./tooltip-content");
var filter_component_module_css_1 = __importDefault(require("./filter-component.module.css"));
var variables_1 = require("../../styles/variables");
var drawer_context_1 = require("../nerdwallet-plus-drawer-sticky-button/drawer-context");
var FilterComponent = function (_a) {
    var _b;
    var onFilterClick = _a.onFilterClick, onTooltipClick = _a.onTooltipClick, onClickHyperlink = _a.onClickHyperlink, _c = _a.defaultFilterState, defaultFilterState = _c === void 0 ? false : _c, _d = _a.href, href = _d === void 0 ? "" : _d, _e = _a.filterLabel, filterLabel = _e === void 0 ? null : _e, _f = _a.tooltipPlacement, tooltipPlacement = _f === void 0 ? "top" : _f;
    var open = (0, drawer_context_1.useDrawerContext)().open;
    var _g = (0, react_1.useState)(defaultFilterState), isFilterOn = _g[0], setIsFilterOn = _g[1];
    var toggleFilter = function () {
        setIsFilterOn(!isFilterOn);
        onFilterClick();
    };
    var tooltipCtaClickHandler = function () {
        onClickHyperlink === null || onClickHyperlink === void 0 ? void 0 : onClickHyperlink();
        open();
    };
    (0, react_1.useEffect)(function () {
        setIsFilterOn(defaultFilterState);
    }, [defaultFilterState]);
    return (react_1.default.createElement(currency_1.Box, { className: (0, classnames_1.default)(filter_component_module_css_1.default.filterComponentBox, (_b = {},
            _b[filter_component_module_css_1.default.isFilterOn] = isFilterOn,
            _b)), width: { mobile: "100" }, paddingY: 1, paddingX: 3 },
        react_1.default.createElement(currency_1.Box, { display: "inline-flex" },
            react_1.default.createElement(currency_1.Type, { className: filter_component_module_css_1.default.filterLabel }, filterLabel ? (filterLabel) : (react_1.default.createElement(currency_1.Type, { bold: true },
                "ELIGIBLE FOR",
                " ",
                react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { verticalAlign: "center", height: 16, small: true }),
                " ",
                "REWARD"))),
            react_1.default.createElement(currency_1.Box, { className: filter_component_module_css_1.default.tooltipOuterBox },
                react_1.default.createElement(currency_1.Tooltip, { content: react_1.default.createElement(tooltip_content_1.TooltipContent, { onClickHyperlink: tooltipCtaClickHandler, href: href }), placement: tooltipPlacement, onClick: onTooltipClick, className: filter_component_module_css_1.default.tooltip },
                    react_1.default.createElement(Help_1.default, { className: filter_component_module_css_1.default.paddingHelp, size: 18 })))),
        react_1.default.createElement(currency_1.Box, { paddingLeft: "3-half" },
            react_1.default.createElement(Switch_1.default, { className: (0, classnames_1.default)(filter_component_module_css_1.default.toggleFilter, {
                    isFilterOn: isFilterOn,
                }), sx: {
                    "& .MuiSwitch-thumb": {
                        opacity: 1,
                    },
                    "& .MuiSwitch-track": {
                        // Overriding default active state with important keyword is needed here
                        backgroundColor: isFilterOn
                            ? "".concat(variables_1.colors["green-dark"], " !important")
                            : "",
                        opacity: "1 !important",
                    },
                    transform: "scale(1.4)",
                }, onClick: toggleFilter, checked: isFilterOn }))));
};
exports.default = FilterComponent;
